import React, {useEffect} from "react";
import './css/Main.css';
import {IProps} from "../../interfaces/IProps";
import { HashLink as Link } from 'react-router-hash-link';
import LazyLoad from 'react-lazyload';
import address from './../../assets/images/map/address.png';

export const Main: React.FC<IProps> = (props: IProps) => {
    const { date, declarationsData } = { ...props };
    const dateString: string = `${date!.day}.${date!.month}.${date!.year}`;
    const pageTitle: string = 'Головна сторінка';
    const mapHref: string = `
        https://www.google.com/maps/place/
        Третя+Черкаська+міська+лікарня+швидкої+медичної+допомоги/
        @49.4089327,32.0494007,17z/
        data=!4m5!3m4!1s0x40d14be984753a5d:
        0xa530beddd4f39740!8m2!3d49.4098013!4d32.0500662
    `;
    const powerBiUrl = `https://app.powerbi.com/view?r=eyJrIjoiODMzYzdkMWUtMmE4Ny00MjQ3LWE4M2UtNDhhMjhmMDJhN2ViIiwidCI6IjY4OGJkYTk3LWZkNWMtNDM2Yy04N2JjLTQ4YWFkNGRkMDg0YyIsImMiOjl9&pageName=ReportSection`;

    useEffect(() => {
        document.title = pageTitle;
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="Main">
            <div className="container-custom">
                <section className="contact">
                    <h3 className="title">
                        Де ми знаходимося та як з нами зв'язатися?
                    </h3>
                    <div className="infobox">
                        <h4>
                            <img
                                className="icon"
                                src="https://i.imgur.com/ZP5JAFK.png"
                                alt="Phone" /> Телефони:
                        </h4>
                        <p className="text">
                            секретар - 64-81-88;
                            <br/>
                            реєстратура - 64-16-16, 71-16-18, 31-66-67;
                        </p>
                    </div>
                    <div className="infobox">
                        <h4>
                            <i className="fas fa-envelope" /> Email:
                        </h4>
                        <p className="text">
                            poliklinika3@i.ua
                            <br/>
                            info@poliklinika3.com.ua
                        </p>
                    </div>
                    <div className="infobox">
                        <h4>
                            <i className="fas fa-map-marker-alt" /> Адреса:
                        </h4>
                        <p className="text">
                            вул. Самійла Кішки 210, 18028, м. Черкаси
                        </p>
                        <LazyLoad height={200} offset={100}>
                            <a href={ mapHref }
                               className="link"
                               target="_blank"
                               rel="noopener noreferrer">
                                <img src={ address }
                                     className="image"
                                     alt="Google Maps address" />
                            </a>
                        </LazyLoad>
                    </div>
                </section>
                <section className="content custom-content">
                    <h3 className="title">
                        Мапа пунктів тестування на COVID-19
                    </h3>
                    <div className="infobox">
                        <iframe title="covid-testing-map"
                                width="100%"
                                height="100%"
                                src={powerBiUrl}
                                frameBorder={0}
                                allowFullScreen={true}
                        >
                            Розташування пунктів тестування на COVID-19
                        </iframe>
                    </div>
                </section>
                <section className="content">
                    <h3 className="title">
                        Департамент охорони здоров'я та
                        медичних послуг Черкаської міської
                        ради інформує:
                    </h3>
                    <div className="textbox">
                        <p className="text">
                            Національна компанія з вибору лікаря
                            стартувала в місті Черкаси 02.04.2018
                            року. Обрати свого лікаря - означає
                            визначитись з терапевтом, педіатром
                            чи сімейним лікарем, якому Ви готові
                            довірити своє здоров’я.
                        </p>
                        <p className="text">
                            Підписавши з ним декларацію, Ви
                            повідомляєте державу, що гроші на
                            Ваше обслуговування повинні направлятися
                            саме у той заклад в якому працює вибраний
                            Вами лікар.
                        </p>
                        <h4 className="subtitle">
                            Станом нa {dateString} по закладу
                            зареєстровано
                            &nbsp;
                            {declarationsData!.calculations.genSum}
                            &nbsp;
                            декларацій
                        </h4>
                        <p className="text">
                            Щодо кількості заключних декларацій
                            по кожному конкретному лікарю можна
                            дізнатись за посиланням - на
                            &nbsp;
                            <a href="https://nszu.gov.ua/e-data/dashboard/pmd-map"
                               rel="noopener noreferrer"
                               className="link"
                               target="_blank"
                            >
                                сайті НЗСУ
                            </a>
                            &nbsp;
                            або у розділі «Публічна інформація» -
                            &nbsp;
                            <Link to="/public-info#declarations-amount"
                                  className="navlink"
                            >
                                «кількість заключних декларацій по лікарям»
                            </Link>
                        </p>
                    </div>
                </section>
                <section className="content">
                    <h3 className="title">
                        Вибір сімейного лікаря
                    </h3>
                    <div className="textbox">
                        <p className="text">
                            Шановні мешканці м. Черкаси! Згідно
                            з наказом МОЗ України від 19.03.2018
                            № 503 «Про затвердження Порядку вибору
                            лікаря, який надає первинну медичну
                            допомогу, та форми декларації про вибір
                            лікаря, який надає первинну медичну
                            допомогу» сімейними лікарями та
                            дільничними педіатрами Черкаських міських
                            центрів первинної медико-санітарної
                            допомоги (у минулому – міські поліклініки)
                            проводиться укладання декларацій з пацієнтами.
                        </p>
                        <p className="text">
                            У зв’язку з необхідністю часу заповнення
                            декларації (15–20 хв.) просимо додатково
                            попередньо записуватися до вибраних
                            Вами лікарів (особисто у реєстратурах
                            або за телефонами реєстратур центрів
                            первинної медико-санітарної допомоги).
                        </p>
                        <p className="text">
                            Мешканцям 14 років та дорослим при
                            собі мати оригінали наступних документів,
                            за можливості їх копії:
                        </p>
                        <ul className="items">
                            <li className="items__item">
                                Паспорт.
                            </li>
                            <li className="items__item">
                                Ідентифікаційний код платника
                                податків (РНОКПП).
                            </li>
                            <li className="items__item">
                                Законні представники пацієнта
                                додатково подають документи,
                                що посвідчують його особу
                                (паспорт, РНОКПП) та
                                повноваження законного
                                представника,
                                відповідно до законодавства.
                            </li>
                        </ul>
                        <p className="text">
                            Для дітей до 14 років батьки
                            (законні представники) надають
                            лікарю оригінали документів, за
                            можливості їх копії:
                        </p>
                        <ul className="items">
                            <li className="items__item">
                                Свідоцтво про народження
                                дитини (діти до 14 років).
                            </li>
                            <li className="items__item">
                                Паспорт (батьків, законного
                                представника).
                            </li>
                            <li className="items__item">
                                Ідентифікаційний код платника
                                податків (РНОКПП) батьків,
                                законного представника.
                            </li>
                            <li className="items__item">
                                Посвідчення законного представника,
                                відповідно до законодавства.
                            </li>
                        </ul>
                        <p className="text">
                            Інформацію про сімейних лікарів та
                            педіатрів розміщено на сайтах
                            Департаменту охорони здоров’я та
                            медичних послуг Черкаської міської
                            ради та міських центрів первинної
                            медико-санітарної допомоги.
                        </p>
                        <p className="text">
                            Переглянути інформацію щодо сімейних
                            лікарів "Черкаського міського центру
                            первинної медико-санітарної допомоги"
                            можна у розділі -
                            &nbsp;
                            <Link to="/employees#section-title"
                                  className="navlink"
                            >
                                «Працівники»
                            </Link>
                        </p>
                    </div>
                </section>
                <section className="content">
                    <h3 className="title">
                        Урядова програма «Доступні ліки»
                    </h3>
                    <div className="textbox">
                        <p className="text">
                            1 квітня 2017 року стартує Урядова
                            програма «Доступні ліки». Пацієнти
                            зможуть отримати ліки від серцево-судинних
                            захворювань, діабету ІІ типу та бронхіальної
                            астми безкоштовно або з незначною доплатою.
                        </p>
                        <p className="text">
                            Мета програми «Доступні ліки» – забезпечити
                            кожного громадянина України необхідними
                            лікарськими засобами, які покращать якість
                            їхнього життя і запобіжать виникненню
                            ускладнень та передчасної смертності.
                        </p>
                        <p className="text">
                            За рецептом звертайтесь до свого
                            сімейного лікаря.
                        </p>
                        <div className="subtitle">
                            <Link to="/public-info#available-medicine-program"
                                  className="navlink"
                            >
                                Список аптек, які відпускають ліки
                                по програмі «Доступні ліки»
                            </Link>
                        </div>
                        <div className="subtitle">
                            <a href="https://mymedcabinet.com.ua"
                               rel="noopener noreferrer"
                               className="link"
                               target="_blank"
                            >
                                Online запис на прийом до лікаря
                            </a>
                        </div>
                        <div className="subtitle">
                            <Link to="/public-info#paid-services-rate"
                                  className="navlink"
                            >
                                Про встановлення тарифів на платні послуги
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
